/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cli_Tools_MenuInputs */

const en_cli_tools_menu = /** @type {(inputs: Cli_Tools_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI Tools menu`)
};

const fr_cli_tools_menu = /** @type {(inputs: Cli_Tools_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu outils CLI`)
};

const de_cli_tools_menu = /** @type {(inputs: Cli_Tools_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI-Tools-Menü`)
};

const it_cli_tools_menu = /** @type {(inputs: Cli_Tools_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu Strumenti CLI`)
};

const ru_cli_tools_menu = /** @type {(inputs: Cli_Tools_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Меню «Инструменты» командной строки`)
};

const es_cli_tools_menu = /** @type {(inputs: Cli_Tools_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menú Herramientas CLI`)
};

const zh_cn2_cli_tools_menu = /** @type {(inputs: Cli_Tools_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI 工具菜单`)
};

const ja_cli_tools_menu = /** @type {(inputs: Cli_Tools_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLIツールメニュー`)
};

const hi_cli_tools_menu = /** @type {(inputs: Cli_Tools_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CLI टूल्स मेनू`)
};

const pt_pt2_cli_tools_menu = /** @type {(inputs: Cli_Tools_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu de ferramentas CLI`)
};

/**
* | output |
* | --- |
* | "CLI Tools menu" |
*
* @param {Cli_Tools_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cli_tools_menu = /** @type {((inputs?: Cli_Tools_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cli_Tools_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_cli_tools_menu(inputs)
	if (locale === "de") return de_cli_tools_menu(inputs)
	if (locale === "it") return it_cli_tools_menu(inputs)
	if (locale === "ru") return ru_cli_tools_menu(inputs)
	if (locale === "es") return es_cli_tools_menu(inputs)
	if (locale === "zh-CN") return zh_cn2_cli_tools_menu(inputs)
	if (locale === "ja") return ja_cli_tools_menu(inputs)
	if (locale === "hi") return hi_cli_tools_menu(inputs)
	if (locale === "pt-PT") return pt_pt2_cli_tools_menu(inputs)
	return en_cli_tools_menu(inputs)
});